import React, { useState } from "react";
import Avatar from "../components/Avatar";
import { svgs } from "../common/assats";
import PopUp from "../components/PatientCharts/PopUp";
import { getFirstLettersOfFirstTwoWords } from "../common/function/getNameShort";
import "./UserInfoContainer.scss";
import { useTranslation } from "react-i18next";
import { User } from "../common/types/user";


interface UserInfoContainerProps {
  user: User;
  onNavigate: (path: string, state?: any) => void;
}

const UserInfoContainer: React.FC<UserInfoContainerProps> = ({
  user,
  onNavigate,
}) => {
  const [popupOpen, setPopupOpen] = useState(false);

  const { t } = useTranslation();

  const handleMoreClick = (e: React.MouseEvent) => {
    setPopupOpen(true);
  };

  const handleProfileClick = () => {
    onNavigate("/Home/EditProfile", { state: { user } });
    setPopupOpen(false);
  };

  const handleDocumentationClick = () => {
    onNavigate("/Home/Documentation");
    setPopupOpen(false);
  };
  const fullName = `${user.firstName} ${user.lastName}`;
  return (
    <div className="user-info-container">
      <Avatar
        initials={getFirstLettersOfFirstTwoWords(fullName).toUpperCase()}
      />
      <div className="user-text-container">
        <span className="full-name-text">{user.role}</span>
        <span className="user-name-text">{fullName}</span>
      </div>
      <svgs.menu.More className="icon" onClick={handleMoreClick} />

      <PopUp
        open={popupOpen}
        onCancel={() => setPopupOpen(false)}
        customClass="user-info-popup"
        content={
          <div className="popup-menu">
            <button className="popup-option" onClick={handleProfileClick}>
              {t("popUp.profile")}
            </button>
            <button className="popup-option" onClick={handleDocumentationClick}>
              {t("popUp.documentation")}
            </button>
          </div>
        }
      />
    </div>
  );
};

export default UserInfoContainer;
